export type RequestVersionGuard = {
  next: () => number;
  isCurrent: (requestId: number) => boolean;
  current: () => number;
};

export function createRequestVersionGuard(): RequestVersionGuard {
  let version = 0;
  return {
    next: () => {
      version += 1;
      return version;
    },
    isCurrent: (requestId: number) => requestId === version,
    current: () => version,
  };
}

